import React from "react";
// import TableComandas from "../components/TableComandas";
import AppCtaCteEstacionReactTable from "../table/AppCtaCteEstacionReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const CtaCteEstacion = () => {
  return (
    <>
      <AppCtaCteEstacionReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default CtaCteEstacion;
